import React from "react";
import { TPercentageSize, TPixelSize } from "../../models/StringLiterals";
import { Background } from "./Background";

type TImageProps = {
    url: string;
    borderRadius?: TPixelSize | TPercentageSize;
    border?: string;
    width: TPixelSize | TPercentageSize;
    height: TPixelSize | TPercentageSize;
};

export const Image = (props: React.PropsWithChildren<TImageProps>): JSX.Element => {

    return (
        <Background
            borderRadius={props.borderRadius || "0px"}
            width={props.width}
            height={props.height}
            backgroundImage={`url("${props.url}")`}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="center"
            borderDefinition={props.border}
        />
    );
};
